<template>
    <div class="mobile-navigation" :class="{ 'open': isMobileNavigationOpen }" :data-active-cat="selectedCatIds">
        <div v-show="isNavigationInitialized">
            <div @click="closeNavigation()" class="mobile-close"><i class="fa fa-times"></i> </div>
            <lazy-load component="phywe-avatar-mobile">
              <phywe-avatar-mobile :lang="Sprache"></phywe-avatar-mobile>
            </lazy-load>
            <ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">
                <li class="ddown" v-if="dataContainer1.parent" @click="slideTo(dataContainer1.parent && dataContainer1.parent.parent || null, true)">
                   <span class="nav-direction d-flex align-items-center mHeader">
                        <template v-if="selectedCat">
                            <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                            <div class="flex-fill text-center" >
                                {{selectedCat.details[0].name }}
                            </div>
                        </template>
                    </span>
                </li>

                <li class="ddown" v-for="category in dataContainer1.categories">
                    <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                    <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                        <i class="fa fa-lg fa-caret-right" aria-hidden="true"></i>
                    </span>
                </li>
                <template v-if="dataContainer1.categories[0]">
                    <li class="ddown" v-for="number in dataContainer1.categories[0].siblingCount - dataContainer1.categories.length">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
                <template v-else-if="dataContainer1.parent">
                    <li class="ddown" v-for="number in dataContainer1.parent.childCount">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>

                <!-- extra -->
                <template v-if="breadcrumbs.length == 0">
                  <li class="ddown">
                    <a :href="urlService">
                      <img src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/service.svg" width="25">
                      {{ $translate("Phywe::Template.serviceIconText") }}
                    </a>
                  </li>
                  <li
                    v-if="bonusprogActive"
                    class="ddown bonusprogramm-menu"
                    :class="[{ 'bonusprogramm-special': bonusprogView === 'special' }, { loggedin: $store.getters.isLoggedIn }]"
                  >
                    <a :href="bonusprogUrl" class="ml-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="30px"
                        viewBox="0 -960 960 960"
                        width="30px"
                        fill="#929292"
                        v-if="bonusprogView === 'special' ? $store.getters.isLoggedIn : true"
                        style="min-height: 25px; min-width: 25px;"
                      >
                        <path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm0-80q8 0 15.5-3.5T508-172q41-41 77-55.5t93-14.5q17 0 28.5-11.5T718-282q0-58 14.5-93.5T788-452q12-12 12-28t-12-28q-41-41-55.5-77T718-678q0-17-11.5-28.5T678-718q-58 0-93.5-14.5T508-788q-5-5-12.5-8.5T480-800q-8 0-15.5 3.5T452-788q-41 41-77 55.5T282-718q-17 0-28.5 11.5T242-678q0 58-14.5 93.5T172-508q-12 12-12 28t12 28q41 41 55.5 77t14.5 93q0 17 11.5 28.5T282-242q58 0 93.5 14.5T452-172q5 5 12.5 8.5T480-160Zm100-160q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Zm100 40Z" style="fill: #929292;"></path>
                      </svg>
                      PHYWE Bonusprogramm
                    </a>
                  </li>
                  <template v-if="pid ==='49091'">
                    <li class="ddown">
                      <a :href="com(1)">
                        {{ $translate("Phywe::Template.comShopMenu1") }}
                      </a>
                    </li>
                    <li class="ddown">
                      <a :href="com(2)">
                        {{ $translate("Phywe::Template.comShopMenu2") }}
                      </a>
                    </li>
                    <li class="ddown">
                      <a :href="com(3)">
                        {{ $translate("Phywe::Template.comShopMenu3") }}
                      </a>
                    </li>
                  </template>
                </template>
                <!-- extra -->

            </ul>

            <ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
                <li class="ddown" v-if="dataContainer2.parent" @click="slideTo(dataContainer2.parent && dataContainer2.parent.parent || null, true)">
                   <span class="nav-direction d-flex align-items-center mHeader">
                        <template v-if="selectedCat">
                            <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                            <div class="flex-fill text-center">
                                {{selectedCat.details[0].name }}
                            </div>
                        </template>
                    </span>
                </li>

                <li  class="ddown" v-for="category in dataContainer2.categories">
                    <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                    <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                        <i class="fa fa-lg fa-caret-right" aria-hidden="true"></i>
                    </span>
                </li>
                <template v-if="dataContainer2.categories[0]">
                    <li class="ddown" v-for="number in dataContainer2.categories[0].siblingCount - dataContainer2.categories.length">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
                <template v-else-if="dataContainer2.parent">
                    <li class="ddown" v-for="number in dataContainer2.parent.childCount">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>

                <!-- extra -->
                <template v-if="breadcrumbs.length == 0">
                  <li class="ddown">
                    <a :href="urlService">
                      <img src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/service.svg" width="25">
                      {{ $translate("Phywe::Template.serviceIconText") }}
                    </a>
                  </li>
                  <template v-if="pid ==='49091'">
                    <li class="ddown">
                      <a :href="com(1)">
                        {{ $translate("Phywe::Template.comShopMenu1") }}
                      </a>
                    </li>
                    <li class="ddown">
                      <a :href="com(2)">
                        {{ $translate("Phywe::Template.comShopMenu2") }}
                      </a>
                    </li>
                    <li class="ddown">
                      <a :href="com(3)">
                        {{ $translate("Phywe::Template.comShopMenu3") }}
                      </a>
                    </li>
                  </template>
                </template>
                <!-- extra -->

            </ul>
        </div>

        <template v-if="!isNavigationInitialized">
            <ul class="breadcrumb">
                <li class="btn-close" @click="closeNavigation()"></li>

                <li class="breadcrumb-item">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </li>
            </ul>

            <loading-animation></loading-animation>
        </template>
    </div>
</template>

<script>
import { MediaQueryHelper } from "../helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "../helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        includeLanguage: Boolean
    },

    data()
    {
        return {
            dataContainer1: {
                parent: {},
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null
        };
    },

    computed:
    {
        pid()
        {
          return App.pid;
        },
        urlService()
        {
          return App.myurls.service;
        },
        bonusprogActive()
        {
          // Default to true if no config is set so the link is visible.
          if (App && App.config && typeof App.config.bonusprogActive !== "undefined")
          {
            return !!App.config.bonusprogActive;
          }
          return true;
        },
        bonusprogView()
        {
          return (App.config && App.config.bonusprogView) || "default";
        },
        bonusprogUrl()
        {
          // Try mapped URLs first; fall back to category 1005 path if nothing is set.
          if (App && App.myurls)
          {
            return App.myurls.bonusprog
              || App.myurls.bonusprogramm
              || App.myurls.bonusprogram
              || App.myurls.bonus
              || App.myurls["1005"]
              || "/bonusprogramm/";
          }
          return "/bonusprogramm/";
        },
        selectedCat()
        {
          return this.selectedCategory;
        },
        selectedCatIds()
        {
          let breadcrumbs = this.breadcrumbs;
          if(breadcrumbs.length > 0)
          {
            return breadcrumbs[0].parent.id
          }
          else
          {
            return 0;
          }
        },
        Sprache()
        {
            return App.language;
        },
        breadcrumbs()
        {
            const breadcrumbs = [];
            let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

            while (container && container.parent && Object.keys(container.parent).length)
            {
                breadcrumbs.unshift(
                    {
                        name: container.parent.details[0].name,
                        parent: container.parent || null
                    });

                container = container.parent;
            }

            return breadcrumbs;
        },

        ...mapState({
            navigationTree: state => state.navigation.tree,
            isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
    },

    created()
    {
        this.$store.commit("setCurrentCategory", this.initialCategory);
    },

    mounted()
    {
        this.addEventListener();
    },

    methods:
    {
        com(number)
        {
          if(number === 1)
          {
            return App.myurls.com1
          }
          if(number === 2)
          {
            return App.myurls.com2
          }
          if(number === 3)
          {
            return App.myurls.com3
          }
        },
        addEventListener()
        {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

            if (this.breakpoints.includes(breakpoint))
            {
                this.loadInitialTree();
            }
        },

        loadInitialTree()
        {
            if (this.navigationTree.length <= 0)
            {
                const categoryId = this.initialCategory && this.initialCategory.id ? this.initialCategory.id : null;

                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        this.$store.commit("setNavigationTree", response);
                        this.initNavigation();
                    });
            }
        },

        initNavigation()
        {
            if (this.initialCategory && this.initialCategory.id)
            {
                if (this.initialCategory.linklist === "N")
                {
                    this.$store.commit("setCurrentCategory", this.initialCategory);
                }
                else
                {
                    this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
                    this.initialSlide(this.$store.state.navigation.currentCategory);
                }
            }

            this.dataContainer1.parent = null;
            this.dataContainer1.categories = this.navigationTree;
            this.isNavigationInitialized = true;
        },

        initialSlide(currentCategory)
        {
            if (currentCategory)
            {
                if (currentCategory.children)
                {
                    this.slideTo(currentCategory);
                }
                else if (currentCategory.parent)
                {
                    this.slideTo(currentCategory.parent);
                }
            }
        },

        slideTo(category, back)
        {
            const children = isDefined(category) ? category.children : this.navigationTree;
            const categoryId = isDefined(category) ? category.id : null;

            this.loadPartialTree(categoryId);
            this.selectedCategory = category;

            if (this.useFirstContainer)
            {
                this.dataContainer1.parent = category;
                this.dataContainer1.categories = children || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            }
            else
            {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = children || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

            this.useFirstContainer = !this.useFirstContainer;
        },

        loadPartialTree(categoryId)
        {
            // eslint-disable-next-line eqeqeq
            if (this.selectedCategory != categoryId ||
                (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId))
            {
                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                            (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId))
                        {
                            this.$store.commit("setNavigationTree", response);
                            this.updateDataContainers(categoryId);
                        }
                    });
            }
        },

        updateDataContainers(categoryId)
        {
            const containers = ["dataContainer1", "dataContainer2"];
            const category = this.getCategoryById(categoryId, this.navigationTree);

            for (const container of containers)
            {
                if (category)
                {
                    this[container].parent = category;
                    this[container].categories = category.children;
                }
                else
                {
                    // root level
                    this[container].parent = null;
                    this[container].categories = this.navigationTree;
                }
            }
        },

        getCategoryById(categoryId, tree)
        {
            for (const cat of tree)
            {
                if (categoryId === cat.id)
                {
                    return cat;
                }
                else if (cat.children)
                {
                    const foundCat = this.getCategoryById(categoryId, cat.children);

                    if (foundCat)
                    {
                        return foundCat;
                    }
                }
            }

            return null;
        },

        closeNavigation()
        {
            this.$store.commit("setIsMobileNavigationOpen", false);
        },

        getCategoryUrl(url)
        {
            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

            return prefix + url;
        }
    },

    directives:
    {
        menu: {
            bind(el)
            {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) =>
                {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) =>
                {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () =>
                {
                    $(".mainmenu").removeClass((index, className) =>
                    {
                        return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                    });
                });
            }
        }
    }
}
</script>
